module.exports = __webpack_public_path__ + "static/img/2.36c2827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/hospital/2.png
// module id = H6Rs
// module chunks = 1